module.exports = __webpack_public_path__ + "img/check.a8df350a.png";